<template>
  <div class="post-wrapper container">
    <component :is="id" />
  </div>
</template>

<script>
import hljs from 'highlight.js'

export default {
  computed: {
    id () {
      return () => import('@/assets/posts/' + this.$route.params.id + '.md')
    }
  },
  mounted: () => {
    hljs.initHighlightingOnLoad()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/markd.scss";

.post-wrapper {
  padding: 3rem 2rem;
}
</style>
